import type { JoinResponse } from './api'

/**
 * Hand-off between /join/:token (pre-flight) and /room. The join response —
 * including the LiveKit url+token — is stashed in sessionStorage so a reload
 * of /room can reconnect without re-running pre-flight.
 */
const KEY = 'rt.join.v1'

export interface JoinHandoff {
  linkToken: string
  join: JoinResponse
  /** guest-confirmed display name (falls back to join.display_name / role) */
  displayName: string
  savedAt: number
  /**
   * Pre-flight network verdict (F3 v2.7 #5) — carried into the room and
   * broadcast with the status heartbeat so the studio sees the color dot.
   */
  preflight?: 'green' | 'yellow' | 'red'
  /**
   * Pre-flight grade report (G1 v2.9) — seven items + 'overall', each
   * 'PERFECT'|'GREAT'|'OK'|'POOR'. Broadcast with the in-room status
   * heartbeat (grades field) so the studio sees the medical report.
   */
  grades?: Record<string, string>
}

export function saveJoinHandoff(handoff: JoinHandoff): void {
  sessionStorage.setItem(KEY, JSON.stringify(handoff))
}

export function loadJoinHandoff(): JoinHandoff | null {
  const raw = sessionStorage.getItem(KEY)
  if (!raw) return null
  try {
    const obj = JSON.parse(raw) as JoinHandoff
    if (!obj || !obj.join || !obj.join.livekit) return null
    return obj
  } catch {
    return null
  }
}

export function clearJoinHandoff(): void {
  sessionStorage.removeItem(KEY)
}
